import React from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="page">
      <div style={{ maxWidth: '780px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.2rem', fontWeight: 900, color: 'var(--color-dark)', marginBottom: '0.5rem' }}>
          About knoukno.org
        </h1>
        <p style={{ fontSize: '1.1rem', color: 'var(--color-text-light)', marginBottom: '2.5rem' }}>
          A practical question-and-answer training platform for business owners.
        </p>

        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header">
            <h2 className="card-title">What Kno U Kno Does</h2>
          </div>
          <p style={{ lineHeight: 1.8, color: 'var(--color-text)' }}>
            knoukno.org is built for people who want to run a real business, not just talk about one.
            The platform gives you strong business questions, one page at a time, so you can train your
            thinking in the areas that control outcomes: money, law, operations, people, and growth.
            Each question includes a practical example to show how the issue appears in day-to-day
            business. You read, think, and write your own answer. This creates real clarity because you
            are forced to explain your plan in your own words.
          </p>
          <p style={{ lineHeight: 1.8, color: 'var(--color-text)', marginTop: '0.9rem' }}>
            The process is simple and direct. AI writes the questions. The client writes the answers.
            Answers are saved in MongoDB, and your account is protected with JWT authentication. You can
            return at any time, review your work, and continue improving. Questions are separated with
            pagination so your focus stays on the current decision, not a long overwhelming list.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header">
            <h2 className="card-title">How Your Progress Is Measured</h2>
          </div>
          <p style={{ lineHeight: 1.8, color: 'var(--color-text)' }}>
            Every saved answer can be graded and rated. You can score the quality of your answer,
            rate relevance, and track your average over time. This gives you a clear view of readiness.
            If your averages are low, you know where to improve. If your averages are rising, your
            business judgment is getting stronger. Instead of guessing whether you are prepared, you
            can see measurable progress.
          </p>
          <p style={{ lineHeight: 1.8, color: 'var(--color-text)', marginTop: '0.9rem' }}>
            The goal is not perfect test scores. The goal is better business decisions. Better decisions
            produce better execution, fewer legal and financial mistakes, and stronger opportunities to
            generate revenue.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1.5rem' }}>
          <div className="card-header">
            <h2 className="card-title">Question Coverage</h2>
          </div>
          <p style={{ lineHeight: 1.8, color: 'var(--color-text)', marginBottom: '1rem' }}>
            Kno U Kno is designed around up to 175 business questions with examples. These are distributed
            across core business areas so your learning is balanced and practical.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginTop: '0.5rem' }}>
            {[
              { icon: '💰', title: 'Money', desc: 'Cash flow, pricing, budgeting, financing, and profitability decisions' },
              { icon: '⚖️', title: 'Law', desc: 'Business structure, contracts, compliance, and risk protection' },
              { icon: '⚙️', title: 'Operations', desc: 'Process design, quality control, systems, and execution consistency' },
              { icon: '👥', title: 'People', desc: 'Hiring, performance, onboarding, and team development' },
              { icon: '📈', title: 'Growth', desc: 'Sales pipeline, expansion choices, and scalable strategy' },
            ].map(area => (
              <div key={area.title} style={{ background: 'var(--color-snow)', borderRadius: 'var(--radius)', padding: '1rem' }}>
                <div style={{ fontSize: '1.75rem', marginBottom: '0.4rem' }}>{area.icon}</div>
                <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--color-dark)', marginBottom: '0.3rem' }}>{area.title}</div>
                <div style={{ fontSize: '0.82rem', color: 'var(--color-text-light)', lineHeight: 1.5 }}>{area.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="card" style={{ marginBottom: '2rem' }}>
          <div className="card-header">
            <h2 className="card-title">Our Plans</h2>
          </div>
          <div style={{ lineHeight: 1.8, color: 'var(--color-text)' }}>
            <p><strong>Free Tier:</strong> 5 questions, save page, print page, and 3-day access at $0.</p>
            <p style={{ marginTop: '0.5rem' }}><strong>Members Tier:</strong> Questions 1 to 50, with bonus access through 150, plus print, save, grade, rate, and average tools. $49.00 to $39.00.</p>
            <p style={{ marginTop: '0.5rem' }}><strong>Pro Tier:</strong> Questions 1 to 75, with bonus access through 175, with full answer tools. $675.00 to $436.00.</p>
            <p style={{ marginTop: '0.5rem' }}><strong>Bonus Access:</strong> Included in Members and Pro.</p>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/register" className="btn btn-primary btn-lg">Start Your Free Trial</Link>
        </div>
      </div>
    </div>
  );
}
